// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"587":"1fc4cafb","662":"ad998b87"}[chunkId] + ".chunk.css";
};